import React from "react";
import ReactWizard from "react-bootstrap-wizard";
import { motion } from "framer-motion";
import { Col } from "reactstrap";
import { useTranslation } from "react-i18next";

// wizard steps
import Step1 from "./WizardSwitch/Step1.jsx";
import Step2 from "./WizardSwitch/Step2.jsx";

const WizardSwitch = () => {
  const { t } = useTranslation('wizard');
  const steps = [
    {
      stepName: t('switches.step1Name'),
      stepIcon: "tim-icons icon-settings",
      component: Step1,
    },
    {
      stepName: t('switches.step2Name'),
      stepIcon: "tim-icons icon-link-72",
      component: Step2,
    }
  ];
  return (
    <>
      <div className="content">
        <motion.div initial={{ opacity: 0.5, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
          <Col className="mr-auto ml-auto" md="10">
            <ReactWizard
              steps={steps}
              navSteps
              previousButtonText={t('previous')}
              finishButtonText={t('finish')}
              nextButtonText={t('next')}
              finishButtonClasses="hidden"
              title={t('switches.setupTitle')}
              description=""
              headerTextCenter
              nextButtonClasses="btn-wd btn-info"
              previousButtonClasses="btn-wd"
              progressbar
              color="blue"
            />
          </Col>
        </motion.div>
      </div>
    </>
  );
};

export default WizardSwitch;
